import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs';
import { McToastService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { ClearIaContent, GenerateIaContent } from './entity-ia-content.actions';
import { EntityIaContentService } from '@app/_services/entity-ia-content/entity-ia-content.service';
import { TYPE_PROMPT } from '@app/_models/entity-ia-content/entity-ia-content.model';

export interface EntityIaContentStateModel {
    generatedContent: string;
    generatingContent: boolean;
}

const initialState: EntityIaContentStateModel = {
    generatedContent: null,
    generatingContent: false,
};

@State<EntityIaContentStateModel>({
    name: 'ImEntityIaContent',
    defaults: initialState,
})
@Injectable()
export class EntityIaContentState {
    constructor(
        private toast: McToastService,
        private translate: TranslateService,
        private entityIaContentService: EntityIaContentService
    ) {}

    @Selector()
    public static getGeneratedContent(state: EntityIaContentStateModel) {
        return state.generatedContent;
    }

    @Selector()
    public static getLoading(state: EntityIaContentStateModel) {
        return state.generatingContent;
    }

    @Action(GenerateIaContent)
    public GenerateIaContent({ patchState }: StateContext<EntityIaContentStateModel>, { payload }: GenerateIaContent) {
        patchState({
            generatingContent: true,
        });
        return this.entityIaContentService.generateIaContent(payload).pipe(
            tap((response) => {
                if (response.success) {
                    this.toast.success(this.translate.instant('app.global.modals.EntityIaContent.toasts.success'));
                    switch (payload.typePrompt) {
                        case TYPE_PROMPT.PRODUCT_CONTENT_GENERATION:
                            patchState({
                                generatedContent: response?.data?.texto,
                            });
                            break;
                        case TYPE_PROMPT.POST_CONTENT_GENERATION:
                            patchState({
                                generatedContent: response?.data?.iacontent?.texto,
                            });
                            break;
                        default:
                            patchState({
                                generatedContent: response?.data?.texto,
                            });
                            break;
                    }
                } else {
                    this.toast.danger(this.translate.instant('app.global.modals.EntityIaContent.toasts.error'));
                }
                patchState({
                    generatingContent: false,
                });
            }),
            catchError((error) => {
                patchState({
                    generatingContent: false,
                });
                this.toast.danger(this.translate.instant('app.global.modals.EntityIaContent.toasts.error'));
                throw error;
            })
        );
    }

    @Action(ClearIaContent)
    public ClearIaContent({ patchState }: StateContext<EntityIaContentStateModel>) {
        patchState({ generatedContent: null, generatingContent: false });
    }
}
